module.exports = __webpack_public_path__ + "img/Ziegen.a09269e8.jpg";